import React, { CSSProperties } from 'react';
import { MIconName } from './MIcon.model';
import MIconView from './MIcon.view';

type Props = {
  name: MIconName | string;
  className?: string;
  size?: 's' | 'sm' | 'm' | 'l';
  style?: CSSProperties;
  viewBox?: string;
};

const MIcon: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MIconView style={props.style} name={props.name} className={props.className} size={props.size} viewBox={props.viewBox}></MIconView>
  );
};

MIcon.displayName = 'MIcon';
MIcon.defaultProps = {};

export default MIcon;
